import { consumirServicioEncirptacion } from "api/index";
import {
  ambienteAplicacion,
  urlEmisionPoliza,
  urlGuardarPlanes,
  urlTarifacionCotizadorMex,
} from "constants/urls";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  FetchIdCotizacionActual,
  FetchIngresoInfCliente,
  FetchTarifacion,
} from "redux/actionsMex/aCarrito";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import SimpleToast from "../Toasts/SimpleToas";
import ResumenLayout from "./ResumenLayout";

class ResumenTravelEmpresa extends Component {
  state = {
    dataPago: {
      idPlazo: "1",
      formaPago: "contado",
      labelPlazo: "CONTADO",
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      ObjDatosTarifacion: this.props.dataTarifacion
        ? this.props.dataTarifacion
        : undefined,
      mostrarActualizar: false,
      validate: false,
      valMinimo: this.props.dataCatalogo.diasNumero.diasValorMinimo
        ? this.props.dataCatalogo.diasNumero.diasValorMinimo
        : 100,
      valMaximo: this.props.dataCatalogo.diasNumero.diasValorMaximo
        ? this.props.dataCatalogo.diasNumero.diasValorMaximo
        : 500,
    };
  }

  showToast(mensaje) {
    const { toastManager } = this.props;
    toastManager.add(<SimpleToast text={mensaje} />, {
      appearance: "warning",
    });
  }

  async componentDidMount() {
    //Cargar valores de resumen
    if (this.props.UsuarioDatos && this.props.UsuarioDatos.userIsLoggedIn === false) {
      if (this.props.ingresoinfUsuario === false) {
        await this.props.setInformacionCliente(false);
      }
    }
    await this.CargarResumen();
  }

  CargarResumen = async () => {
    await this.setState({ loading: true });
    const queryParams = new URLSearchParams(this.props.location.search);
    const id = queryParams.get("id");
    if (id !== undefined && id !== "" && id !== null && this.props.dataTarifacion) {
      //SetearVariable Global de id de Cotizacion Actual
      let cotActual = { cotizador: "TRAVELBTA", id: id };
      await this.props.setIdCotizacionActual(cotActual);
      //Verificar si en redux es la cotizacion actual
      if (this.props.dataTarifacion.cotCodigo !== id) {
        //COnsumir servicio de tarifacion
        let ObjRecuperarCarrito = {
          ambiente: ambienteAplicacion,
          cotCodigo: id,
        };
        let dataT = await consumirServicioEncirptacion(
          urlTarifacionCotizadorMex,
          ObjRecuperarCarrito
        );
        if (dataT.transaccion && dataT.transaccion === true) {
          this.setState({ ObjDatosTarifacion: dataT.datosTarifacion });
          this.props.datosTarifacion(dataT.datosTarifacion);
        }
      }
    }

    await this.setState({ loading: false });
  };

  onEliminarPlan = async (pos) => {
    let { ObjDatosTarifacion } = this.state;
    ObjDatosTarifacion.planes[pos.posicion] = {
      ...ObjDatosTarifacion.planes[pos.posicion],
      diasNumero: "0",
    };
    this.setState({ ObjDatosTarifacion, mostrarActualizar: true });

    //Llamar a los servicios deactualizacion y tarifacion
    this.onActualizarCotizacion(ObjDatosTarifacion.planes);
  };

  onActualizarCotizacion = async (datos, useLoading = true) => {
    this.setState({ loading: useLoading });

    const queryParams1 = new URLSearchParams(this.props.location.search);
    const id1 = queryParams1.get("id");

    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: PRODUCTOS.TRAVELBTA,
      pasoCodigo: "planes",
      tarifacionPantallaDos: false,
      idCotizacion: id1,
      usuCotiza: this?.props?.UsuarioDatos?.cliCodigoCore || "",
      items: {
        cotCodigo: id1,
        planes: datos,
      },
    };

    if (this.props.UsuarioDatos && this.props.UsuarioDatos.userIsLoggedIn) {
      Data.items.usuCotiza = { usuCodigo: this.props.UsuarioDatos.cliCodigoCore };
    }

    const res = await consumirServicioEncirptacion(urlGuardarPlanes, Data);
    if (res?.transaccion === true && res?.data) {
      this.setState({ ObjDatosTarifacion: res?.data.datosTarifacion });

      this.props.datosTarifacion(res?.data.datosTarifacion);
    } else {
      return this.showToast(
        "Ha ocurrido un problema al guardar la información de la tarifación"
      );
    }

    this.setState({ loading: false, mostrarActualizar: false });
  };

  onActualizarValoresTarifa = async () => {
    let { mostrarActualizar, ObjDatosTarifacion } = this.state;
    if (mostrarActualizar && mostrarActualizar === true) {
      //Llamar a los servicios deactualizacion y tarifacion

      try {
        const totalDias = ObjDatosTarifacion.planes
          .map((e) => Number(e.diasNumero))
          .reduce((acum, dias) => acum + dias);

        if (totalDias > this.state.valMaximo || totalDias < this.state.valMinimo) {
          return this.props.addWarningToast(
            `El mínimo de dias es de ${this.state.valMinimo} y el máximo de dias es de ${this.state.valMaximo}`
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.onActualizarCotizacion(ObjDatosTarifacion.planes);
      }
    }
  };

  onClickPagar = async () => {
    this.setState({ loading: true });

    const Data = {
      datosCotizador: {
        ambiente: ambienteAplicacion,
        prodCodigo: "TRAVELBTA",
        cotPasoCodigo: "crearPoliza",
        cotCodigo: this.props.dataTarifacion.cotCodigo,
      },
    };

    const res = await consumirServicioEncirptacion(urlEmisionPoliza, Data);

    if (res.transaccion && res.catalogo.idPoliza) {
      const route = res?.catalogo?.pasosRedireccionamiento.find(
        (e) => e.codigo === "resumen"
      );

      return this.props.history.push(route.goTo);
    }
    this.setState({ loading: false });
  };

  setter = (props) => {
    this.setState(props);
  };

  render() {
    let { loading, ObjDatosTarifacion, mostrarActualizar, valMaximo, valMinimo } =
      this.state;
    return (
      <ResumenLayout
        LoadingInfCliente={this.props.LoadingInfCliente}
        loading={loading}
        ObjDatosTarifacion={ObjDatosTarifacion}
        dataTarifacion={this.props.dataTarifacion}
        mostrarActualizar={mostrarActualizar}
        onEliminarPlan={this.onEliminarPlan}
        valMaximo={valMaximo}
        valMinimo={valMinimo}
        onActualizarValoresTarifa={this.onActualizarValoresTarifa}
        onClickPagar={this.onClickPagar}
        setState={this.setter}
        onActualizarCotizacion={this.onActualizarCotizacion}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  dataTarifacion: state.CarritoMex.setTarifacion,
  dataCatalogo: state.CatalogosMex.setCatalogoBtaEmpresas,
  LoadingInfCliente: state.CarritoMex.setLoadingCotizador,
  ingresoinfUsuario: state.CarritoMex.setIngresoInfCliente,
});

const mapDispatchToProps = (dispatch) => {
  return {
    datosTarifacion: (datos) => dispatch(FetchTarifacion(datos)),
    setIdCotizacionActual: (datos) => dispatch(FetchIdCotizacionActual(datos)),
    setInformacionCliente: (datos) => dispatch(FetchIngresoInfCliente(datos)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResumenTravelEmpresa)
);
